import { useTranslation } from 'react-i18next'
import { Card, CardContent } from '@/components/ui/card'
import type { DerivedColumn, DerivedColumnPreview } from '@/services/api/structuredIngest'

export function DerivedColumns({
  columns,
  preview,
  rowsTotal,
}: {
  columns: DerivedColumn[]
  preview: DerivedColumnPreview[]
  rowsTotal: number
}) {
  const { t } = useTranslation()
  const results = new Map(preview.map(column => [column.name, column]))
  return (
    <div className="flex flex-col gap-3">
      <p className="text-sm text-muted-foreground">{t('tableMapping.derived.intro')}</p>
      {columns.map(column => {
        const result = results.get(column.name)
        return (
          <Card key={column.name}>
            <CardContent className="p-3 text-sm">
              <p className="font-medium">{column.name}</p>
              <p className="text-xs text-muted-foreground">
                {column.path
                  ? t('tableMapping.derived.path', {
                      path: column.path,
                      source: column.source_column,
                    })
                  : t('tableMapping.derived.field', {
                      field: column.field,
                      source: column.source_column,
                    })}
              </p>
              {column.template && (
                <p className="mt-2 break-words font-mono text-xs">{column.template}</p>
              )}
              {result?.error && (
                <p className="mt-2 text-xs text-destructive">
                  {t('tableMapping.derived.error', {
                    error: result.error,
                  })}
                </p>
              )}
              {result && !result.error && (
                <p className="mt-2 text-xs text-muted-foreground">
                  {t('tableMapping.derived.rows', {
                    matched: result.matched_rows,
                    total: rowsTotal,
                  })}
                  {result.examples.length > 0 && ` · ${result.examples.join(' · ')}`}
                </p>
              )}
            </CardContent>
          </Card>
        )
      })}
    </div>
  )
}
